/**
 * @license
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 *
 * g3-prettier-ignore-file
 */

/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as interactions from "../interactions/index.js";
import { GoogleGenAiError } from "./google-gen-ai-error.js";

/**
 * Error getting interaction
 */
export type GetInteractionByIdServerErrorData = {
  /**
   * Error message from an interaction.
   */
  error: interactions.ErrorT;
};

/**
 * Error getting interaction
 */
export class GetInteractionByIdServerError extends GoogleGenAiError {
  /**
   * Error message from an interaction.
   */
  error: interactions.ErrorT;

  /** The original data that was passed to this error instance. */
  data$: GetInteractionByIdServerErrorData;

  constructor(
    err: GetInteractionByIdServerErrorData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.error?.message
      || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;
    this.error = err.error;

    this.name = "GetInteractionByIdServerError";
  }
}

/**
 * Error getting interaction
 */
export type GetInteractionByIdClientErrorData = {
  /**
   * Error message from an interaction.
   */
  error: interactions.ErrorT;
};

/**
 * Error getting interaction
 */
export class GetInteractionByIdClientError extends GoogleGenAiError {
  /**
   * Error message from an interaction.
   */
  error: interactions.ErrorT;

  /** The original data that was passed to this error instance. */
  data$: GetInteractionByIdClientErrorData;

  constructor(
    err: GetInteractionByIdClientErrorData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.error?.message
      || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;
    this.error = err.error;

    this.name = "GetInteractionByIdClientError";
  }
}
